<script>
import DetailingForm from './DetailingForm'

export default {
  extends: DetailingForm,

  methods: {
    onSubmit() {
      this.createDetailing(this.form)
        .then(() => {
          this.successSubmit({ message: 'Детализация успешно создана', routeName: 'detailing' })
        })
        .finally(() => { this.afterSubmit() })
    }
  }
}
</script>